export const TARGET_HANDLE_CLASSNAME =
  'bg-[#6b7280] w-1 h-1 border-1 border-[#6b7280]';
export const SOURCE_HANDLE_CLASSNAME =
  'bg-[#fff] w-1 h-1 border-1 border-[#6b7280]';
